import InventoryMainPage from "./main.container";

export default InventoryMainPage;
